<template>
<input class="form-control" :value="value" @input="$emit('input', $event.target.value)">
</template>

<script>
export default {
  props: {
    value: {required: true}
  }
}
</script>



// WEBPACK FOOTER //
// TextInput.vue?4d0a09a1